import React from 'react'
import CreateMenu from '../../../../components/organisms/admin/menu/special/CreateMenu'

type Props = {}

const CreateMenuPage = (props: Props) => {
  return (
    <CreateMenu />
  )
}

export default CreateMenuPage